import { useMemo } from 'react';
import { Table } from '@skyline-platform/alchemy';
import { renderBadgeForStreamStatus } from '../utils/helpers';
import { ActionModal } from '@skyline-platform/alchemy';
import { StreamActions } from '../streams/StreamActions';
import PropTypes from 'prop-types';
import { StreamUrlsDisplay } from '@components/StreamUrlsDisplay/StreamUrlsDisplay';
import './StreamsTab.css';

export const StreamsTab = ({
  streamData, tableKey, userIsAdmin,
}) => {
  const formattedStreams = useMemo(() => {
    if (!streamData) return [];
    return streamData.map((stream) => ({
      online: stream?.online,
      id: stream.id,
      name: stream.name,
      description: stream?.description,
      onDemand: stream?.pull_on_request,
      rtspInterleave: stream?.use_interleaved_rtsp_transport,
      source: stream?.source?.name,
      zone: stream?.zone?.name,
      appliance: stream?.appliance?.name,
      action: { ...stream },
    }));
  }, [streamData]);

  const StreamUrls = ({ data }) => (
    <StreamUrlsDisplay streamId={data.id} />
  );

  const tableColumns = [
    {
      field: 'online',
      headerName: 'Status',
      cell: (row) => renderBadgeForStreamStatus(row?.online),
      width: '85px',
      sortable: true,
    },
    {
      field: 'name',
      headerName: 'Stream Name',
      type: 'string',
      grow: 1,
      sortable: true,
    },
    {
      field: 'source',
      headerName: 'Stream Profile',
      type: 'string',
      sortable: true,
    },
    {
      field: 'zone',
      headerName: 'Zone',
      type: 'string',
      sortable: true,
    },
    {
      field: 'appliance',
      headerName: 'Appliance',
      type: 'string',
      sortable: true,
    },
    {
      field: 'action',
      headerName: '',
      cell: (row) => (
        <ActionModal
          className='stream-row-actions'
          id={row.name}
          title='Toggle Options'
          content={StreamActions({
            rowInfo: row.action,
            id: row.id,
            userIsAdmin,
          })}
        />
      ),
      width: '50px',
      sortable: false,
    },
  ];

  return (
    <Table
      tableName='Streams'
      // rerenders table on select to update cell class, doesn't work when applied just to cell
      key={`table-${tableKey}`}
      columns={tableColumns}
      className='streams-tab'
      hideInColumnMenu={['action']}
      rows={formattedStreams}
      style={{ height: '100px' }}
      initialSortField='name'
      expandableRows={userIsAdmin ? true : false}
      expandableRowFormat={StreamUrls}
    />);
};

StreamsTab.propTypes = {
  streamData: PropTypes.object,
  tableKey: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
  }),
  userIsAdmin: PropTypes.bool.isRequired,
};